import type { ComponentChildren } from "preact";
import { cn } from "./cn";

export function SectionHeading({
  title,
  description,
  actions,
  level = 3,
  class: extraClass,
}: {
  title: ComponentChildren;
  description?: ComponentChildren;
  actions?: ComponentChildren;
  level?: 2 | 3;
  class?: string;
}) {
  const titleClass =
    level === 2
      ? "text-2xl font-semibold tracking-tight text-fg"
      : "text-base font-semibold tracking-tight text-fg";
  return (
    <div class={cn("flex flex-wrap items-start justify-between gap-3", extraClass)}>
      <div class="min-w-0 space-y-1">
        {level === 2 ? (
          <h2 class={titleClass}>{title}</h2>
        ) : (
          <h3 class={titleClass}>{title}</h3>
        )}
        {description && (
          <p class="text-sm text-fg-subtle">{description}</p>
        )}
      </div>
      {actions && (
        <div class="flex flex-wrap items-center gap-2">{actions}</div>
      )}
    </div>
  );
}
